import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=50588ee8&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=50588ee8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50588ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50588ee8')) {
      api.createRecord('50588ee8', component.options)
    } else {
      api.reload('50588ee8', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=50588ee8&scoped=true", function () {
      api.rerender('50588ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/carousel/Carousel.vue"
export default component.exports